import React, { useEffect, useMemo } from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import { validURL } from '../../utils';

import PreviewBlock from './preview-block';
import { StyledLogo, StyledPreview } from './style';
import { getSerializedBlocks } from '../survey-questions-builder/utils';

type BuilderProps = {
  surveyForm: any;
  accountInfo: any;
};

const Builder = ({ surveyForm, accountInfo }: BuilderProps) => {
  const { blocks, allBlocks, thankyouBlock } = getSerializedBlocks(
    surveyForm?.question_details?.questions || [],
  );

  const form = useForm({
    defaultValues: useMemo(() => {
      return surveyForm;
    }, [surveyForm]),
  });

  const { reset } = form;

  useEffect(() => {
    reset(surveyForm);
  }, [surveyForm]);

  return (
    <StyledPreview
      branding={{
        ...surveyForm?.ui_branding,
        ...surveyForm?.ui_theme,
        brand_color: accountInfo?.brand_color || 'var(--color-elephant-800)',
      }}
    >
      <div className="step-option">
        <div className="builder">
          <div className="brand-logo">
            {validURL(accountInfo?.logo_url) ? (
              <img src={accountInfo?.logo_url} alt="brand logo" />
            ) : (
              <StyledLogo>
                {/* <div className="logoPlaceholder"> your logo </div> */}
                <div className="companyname">
                  {accountInfo?.company_name || surveyForm?.ui_branding?.name}
                </div>
              </StyledLogo>
            )}
          </div>
          <div className="builder-header">
            <div
              style={{
                maxWidth: '480px',
                minWidth: '480px',
                color: 'var(--color-smoke-800)',
                fontSize: '16px',
                lineHeight: '1.8',
                fontWeight: 500,
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {surveyForm?.header_message}
            </div>
          </div>

          <FormProvider {...form}>
            {allBlocks.map((block: any, index: number) => (
              <PreviewBlock
                key={`b-${block.name}`}
                blockIndex={index + 1}
                setOpen={() => {}}
                block={block}
                open={true}
                surveyForm={surveyForm}
                setSurveyForm={() => {}}
                blocks={blocks}
              />
            ))}

            <PreviewBlock
              key={`b-${thankyouBlock?.name}`}
              blockIndex={-1}
              setOpen={() => {}}
              block={thankyouBlock}
              open={true}
              blocks={blocks}
              surveyForm={surveyForm}
              setSurveyForm={() => {}}
              thankYouMessage={true}
            />
          </FormProvider>
          <br />
          <br />
        </div>
      </div>
    </StyledPreview>
  );
};

export default Builder;
